import { render } from "./image.vue?vue&type=template&id=ecd31e72"
import script from "./image.vue?vue&type=script&setup=true&lang=js"
export * from "./image.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/components/image.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ecd31e72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ecd31e72', __exports__)) {
    console.log('reload')
    api.reload('ecd31e72', __exports__)
  }
  
  module.hot.accept("./image.vue?vue&type=template&id=ecd31e72", () => {
    console.log('re-render')
    api.rerender('ecd31e72', render)
  })

}


export default __exports__